import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getBranchAction } from "../asyncActions/branchActions"
import { Box } from "@mui/material"
import DocumentList from "./DocumentList"
import { useTranslation } from "react-i18next"

function AccaountantHomePage(){

    const {t} = useTranslation()

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getBranchAction())
    }, [dispatch])

    const {
        documents
    } = useSelector(store => store.branch)   

    return(
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 10}}>
            <DocumentList documents={documents}/>
        </Box>
    )
}


export default AccaountantHomePage